import { render, staticRenderFns } from "./CSelects.vue?vue&type=template&id=3668137d&scoped=true"
import script from "./CSelects.vue?vue&type=script&lang=js"
export * from "./CSelects.vue?vue&type=script&lang=js"
import style0 from "./CSelects.vue?vue&type=style&index=0&id=3668137d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3668137d",
  null
  
)

export default component.exports